"use client";

import { ACCOUNTING_REMEDIATION_PLAN, type PackageSummary } from "../pricing";
import { ManageRemediationScreen } from "./ManageRemediationScreen";

/**
 * How many past financial years of books need bringing up to date.
 *
 * Reached only from a "yes" on the employer's-returns step. The sub-question
 * and its guidance copy are one span with a <br/> in the export — split into a
 * heading and a paragraph here.
 */
export function ManageAccountingRemediationStep({
  years,
  onYearsChange,
  summary,
  onNext,
  onSkip,
}: {
  years: string | null;
  onYearsChange: (value: string) => void;
  summary: PackageSummary;
  onNext: () => void;
  onSkip: () => void;
}) {
  return (
    <ManageRemediationScreen
      heading="Employer’s returns and management account reports for previous years"
      intro={
        <div className="flex w-full flex-col items-start gap-2">
          <h2 className="font-suisse-intl-bold text-xl leading-snug text-white sm:text-2xl sm:leading-[38.4px]">
            How many previous financial years do you need help with?
          </h2>
          <p className="font-suisse-intl-medium text-base leading-relaxed text-white sm:text-lg sm:leading-[28.8px]">
            If you need help for more than three past financial years, indicate below so that we can
            follow up with you. If you&rsquo;re unsure about the number of outstanding years, start
            by adding one financial year.
          </p>
        </div>
      }
      legend="How many previous financial years do you need help with?"
      name="accounting-remediation-years"
      plan={ACCOUNTING_REMEDIATION_PLAN}
      years={years}
      onYearsChange={onYearsChange}
      summary={summary}
      onNext={onNext}
      onSkip={onSkip}
    />
  );
}
